import {createContext} from 'react'

export const RootElementContext = createContext<HTMLElement | undefined>(undefined)
